import React, { useEffect, useReducer } from "react";
import "../../../app/App.scss";
import { sendRequest } from "../../../common/http";
import { useParams } from "react-router-dom";
import { IntlProvider } from "react-intl";
import ENGLISH from "../../../i18n/languages/en-US.json";
import { pig } from "../../../static/js/pig.js";
import Header from "../../continuous-improvement/export/Header";
import ParticipatingOrganizations from "../../continuous-improvement/export/ParticipatingOrganizations";
import {
  Plan,
  PlanResultSet,
  defaultPlanResultSet,
  defaultPlan
} from "../../common/interfaces/Interface";
import UnauthorizedComponent from "@/features/insights/UnauthorizedComponent";

interface PlanViewStatus {
  locale: string;
  messages: object;
  plans: Plan[];
  selectedPlan: Plan;
  showLoader: boolean;
  showDownloadBtn: boolean;
}

interface PlanViewAction {
  type: string;
  locale: string;
  plan_uuid: string;
  result: PlanResultSet;
  showDownloadBtn: boolean;
}

const defaultAction = {
  type: "",
  locale: "",
  plan_uuid: "",
  result: defaultPlanResultSet,
  showDownloadBtn: true
};

const reducer = (state: PlanViewStatus, action: PlanViewAction) => {
  switch (action.type) {
    case "setPlans":
      return setPlans(state, action);

    case "setLocale":
      return setLocale(state, action.locale);
    case "setShowDownloadBtn":
      return { ...state, showDownloadBtn: action.showDownloadBtn };
    default:
      return state;
  }
};
const setPlans = (state: PlanViewStatus, action: PlanViewAction) => {
  const selectedPlans = action.result.plans.filter((plan: Plan) => {
    return plan.uuid === action.plan_uuid;
  });
  const selectedPlan =
    selectedPlans.length > 0 ? selectedPlans[0] : defaultPlan;

  return {
    ...state,
    plans: action.result.plans,
    selectedPlan: selectedPlan,
    showLoader: false
  };
};

const setLocale = (state: PlanViewStatus, locale: string) => {
  switch (locale) {
    case "pig": {
      return { ...state, locale: "en-US", messages: pig(ENGLISH) };
    }
    default: {
      return { ...state, locale: "en-US", messages: ENGLISH };
    }
  }
};

const getLocaleString = (locale: string | null) => {
  return locale ? locale : "";
};

export interface PlanComponentProps {}

export default function PlanView(): JSX.Element {
  const { reporting_year_uuid: reportingYearUuid, plan_uuid: planUuid } =
    useParams();
  const initialState = {
    locale: "en-US",
    messages: ENGLISH,
    plans: [],
    selectedPlan: defaultPlan,
    showLoader: true,
    showDownloadBtn: true
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const queryString = window.location.search;
    const param = new URLSearchParams(queryString);
    const locale = getLocaleString(param.get("locale"));

    dispatch({ ...defaultAction, type: "setLocale", locale: locale });
  }, []);

  useEffect(() => {
    const applyResult = (result: PlanResultSet) => {
      dispatch({
        ...defaultAction,
        type: "setPlans",
        result: result,
        plan_uuid: planUuid
      });
    };

    sendRequest(
        {
          uri: `/plans?reporting_year_uuid=${reportingYearUuid}`,
          camelize: true
        },
        applyResult
      );
  }, []);
  return (
    <>
      <div className="pagewrapper participation-container">
          <div className="insights-hub-body flex-row">
            <div className="nav-main">
              <div className="contentwrapper">
                <main id="maincontent" className="main-container">
                  {state.messages && (
                    <IntlProvider
                      locale={state.locale}
                      messages={state.messages}
                    >
                      <Header
                        showLoader={state.showLoader}
                        title={state.selectedPlan.title}
                        planType={state.selectedPlan.assessmentTypeId}
                        showDownloadBtn={state.showDownloadBtn}
                      />
                      <ParticipatingOrganizations
                        plan={state.selectedPlan}
                        showDownloadBtnChange={(showDownloadBtn: boolean) =>
                          dispatch({
                            ...defaultAction,
                            type: "setShowDownloadBtn",
                            showDownloadBtn: showDownloadBtn
                          })
                        }
                      />
                    </IntlProvider>
                  )}
                </main>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}
